import { useAuth } from "@common/contexts/auth/AuthProvider";
import React, { useEffect } from "react";
import { Route, useLocation } from "react-router-dom";
import LoadingView from "@common/components/loading/LoadingView"

function AuthRoute({ component: Component, render, ...routeProps }) {
  const { redirectToSignIn, authenticated } = useAuth();

  useEffect(() => {
    if (authenticated) return;
    if (routeProps.location.pathname.includes('mypage')) {
      redirectToSignIn();
    }
  }, [authenticated, routeProps]);

  if (routeProps.location.pathname.includes('mypage') && !authenticated) return <LoadingView/>;

  return <Route {...routeProps} render={(props) => (render ? render(props) : <Component {...props} />)} />;
}

export default AuthRoute;
